export default __webpack_public_path__ + "static/quattrocento-regular-0a3cfb8e13fe1c714be2d3d0f2a450d1.ttf";